module.exports = __webpack_public_path__ + "static/media/main idea.7708f36f.mp3";